import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_609813884 from "../../../../../packages/component/src/components/search/demo/demo1.js?loadDemo";
import legacyImportDemo_2996191167 from "../../../../../packages/component/src/components/search/demo/demo2.js?loadDemo";
import legacyImportDemo_1058915454 from "../../../../../packages/component/src/components/search/demo/demo3.js?loadDemo";
import legacyImportDemo_4284896441 from "../../../../../packages/component/src/components/search/demo/demo4.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_609813884,
  legacyImportDemo_2996191167,
  legacyImportDemo_1058915454,
  legacyImportDemo_4284896441,
  React
};